module.exports = __webpack_public_path__ + "img/clinical-post.22de1ffc.png";